<template>
	<div>
		<SubNav v-bind:active="2"></SubNav>
		<div class="profile-img">
			<img :src="imgUrl" alt="">
		</div>
		<div class="profile-content">
			<Row>
				<Col span="12" class="text-l back"><router-link to="/news" tag="a">返回列表</router-link></Col>
				<Col span="12" class="text-r share">
                    <div class="social-share"></div>
				</Col>
			</Row>
			<div class="news-details">
				<h1>{{newsDetails.title}}</h1>
				<div v-html="newsDetails.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
    import SubNav from './SubNav.vue'
	import * as profile from '@/controller/profile'

	export default {
		name: "news-details",
        components: {
            SubNav
        },
		data() {
			return {
				imgUrl: '',
				newsDetails: {
					title: '',
					content: ''
				},
				id:this.$route.query.news_id
			}
		},
		mounted() {

            if(navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Android') > -1) {
                alert('asdasasd')
                window.location.href='/mobile/newDet?sign=2&newId=' + this.$route.query.news_id + '&newSign=10'
            }


			if(this.id) {
				this.showNewsDetails(this.id)
			}else {
				this.$router.push({ name: 'news'})
			}

			this.showBanner()
		},
		methods: {
			//显示banner图
			showBanner() {
				profile.fetchBanner()
					.then(result => {
						this.imgUrl = result.imgUrl.news
					})
			},
			//显示新闻详情
			showNewsDetails() {
				profile.fetchNewsDetails(this.id)
					.then(result => {

						this.newsDetails = result.content

						socialShare('.social-share', {
							url: window.location.href + '/news-details?news_id=' + result.content.id +'',
							title: result.content.title,
							disabled: ['google', 'facebook', 'twitter'],
							wechatQrcodeTitle: "微信扫一扫：分享",
							wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>',
                        })
					})
			},
		}
	}
</script>

<style scoped lang="stylus">
	$width = 1000px
	.profile-img
		background-color white
		overflow hidden
		img
			width 100%
	.profile-content
		width $width
		margin 0 auto
		padding 10px
		.text-l
			text-align left
		.text-r
			text-align right
		.back a
			color #EE1234
		.share a
			color #AAAAAA
		.news-details
			padding 10px
			h1
				margin 30px 0
			div
				text-align justify
				line-height 28px
	.profile-content >>> img
		max-width 100%
</style>